"use strict";
import { createContext } from "react";
export const AuthContext = createContext({
  authToken: null,
  authRefreshToken: null,
  setAuthToken: () => {
  },
  setAuthRefreshToken: () => {
  },
  permissions: [],
  setPermissions: () => {
  }
});
